<template>
  <div class="not-found">
    <div class="not-found-container">
      <img :src="src" alt="">
      <div class="tips">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    src () {
      return `${this.$store.getters.imgUrl}/dc-pr/not_found.png`
    },
    text () {
      if (this.data) {
        console.log(JSON.stringify(this.data))
        return `啊哦~该用户尚未在 dartcome.com 申请开通 PR 功能!`
      }
      return '啊哦~找不到该用户'
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.not-found {
  position: relative;
  height: 100%;
  width: 100%;
  text-align: center;
  & .not-found-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    & img {
      max-width: 100%;
      margin: 0 auto;
    }
    & .tips {
      @media (--mediaPc) {
        font-size: var(--textSize0);
      }
      @media (--mediaMobile) {
        font-size: var(--textSize0Mobile);
      }
      color: var(--colorDisabled);
      padding: 70px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/NotFound.vue